module.exports = __webpack_public_path__ + "static/img/employee-avatar.ace33b7f.jpg";